<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">エラー</h3>
		</div>
	</div>
	<form class="kt-form">
		<div class="kt-portlet__body">
			<div class="kt-form__section kt-form__section--first container">
				<div class="row">
					<p>プロジェクトが存在しないか、もしくはあなたにそのプロジェクトを閲覧する権限がありません。</p>
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit">
			<div class="kt-form__actions kt-form__actions--solid">
				<div class="row text-right">
					<div class="col-lg-12">
						<button type="button" (click)="onClick()" mat-raised-button [mat-dialog-close]="" matTooltip="Cancel changes">
							OK
						</button>&nbsp;
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
